<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar />
      </div>
      <div class="flex-fill overflow-auto">
        <CategoriesNav />
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    CategoriesNav: () => import(/* webpackPrefetch: true */ './components/CategoriesNav.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue')
  }
})
export default class Index extends Vue {}
</script>
